import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import Card from '../../../components/Card';
import { Button } from 'primereact/button';
import { postApiCall } from '../../../service/postApiCall';
import { getApiCall } from '../../../service/getApiCall';
import { AGENT_GROUP_CREATE, API_AGENT_UPDATE, API_AGENT_GROUP_EXTENSION, API_USER_COUNTRY_CODE_DIRECTIONS_ME, API_USER_COUNTRY_CODE_DIRECTIONS_BY_AGENT } from '../../../service/url';
import CountryCodeDirectionPicker from '../../../components/partials/dashboard/country-code-direction/CountryCodeDirectionPicker';
import { useNavigate } from 'react-router-dom';
import ToastNotification from '../../../components/Toast';
import { Dropdown } from 'primereact/dropdown';
import { useLocation } from 'react-router-dom';
import {validateEmail} from '../../../utilities/helpers'
import { MultiSelect } from 'primereact/multiselect';
import { toast } from 'react-toastify';
import { MODULE_ACL, FLASH_MESSAGE_ACTION_OBJECT } from '../../../utilities/constant';
import {fetchAndSetFlashMessage } from "../../../service/httpCall";



export default function CreateAgent() {
    const navigate = useNavigate();
    const location = useLocation();
    const agentData = location.state;
    const isEditMode = Boolean(agentData);

    const [agentName, setAgentName] = useState(agentData?.agent_name || '');
    const [agentNumber, setAgentNumber] = useState(agentData?.agent_number || '');
    const [selectedExtension, setSelectedExtension] = useState(
        agentData?.extension?.id || agentData?.extension || null
    );
    const [emailId, setEmailId] = useState(agentData?.email_id || '');
    const [description, setDescription] = useState(agentData?.description || '');
    const [username, setUsername] = useState(agentData?.username || '');
    const [password, setPassword] = useState('');
    const [access, setAccess] = useState(agentData?.access || null);
    const [type, setType] = useState(() =>
    Array.isArray(agentData?.type) ? agentData.type : agentData?.type ? [agentData.type] : []
    );

    const [loginStatus, setLoginStatus] = useState(agentData?.login_status || 'Inactive');

    const [extensionOptions, setExtensionOptions] = useState([]);
    const [showToast, setShowToast] = useState(false);
    const [toastProps, setToastProps] = useState({ type: 'success', message: '' });
    const [emailError, setEmailError] = useState("");
    const [agentNameError, setAgentNameError] = useState("");
    const [usernameError, setUsernameError] = useState("");
    const [notes, setNotes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const [countryCode, setCountryCode] = useState(agentData?.country_code || "");
    const [countryCodeError, setCountryCodeError] = useState("");

    const [cliOption, setCliOption] = useState(agentData?.cli_option || "actual");
    const [isOutboundEnabled, setIsOutboundEnabled] = useState(
        typeof agentData?.is_outbound_enabled === 'boolean' ? agentData.is_outbound_enabled : false
    );

const [passwordRules, setPasswordRules] = useState({
  length: false,
  upper: false,
  lower: false,
  number: false,
  special: false,
  space: true
});

const [passwordError, setPasswordError] = useState("");

const [availableCcDirections, setAvailableCcDirections] = useState([]);
const [selectedCcDirections, setSelectedCcDirections] = useState([]);

    const accessOptions = [
        {label: 'Select Access', value: ''},
        { label: 'Admin', value: 'Admin' },
        { label: 'Regular', value: 'Regular' },
        { label: 'Group Owner', value: 'Group Owner' },
    ];

    const typeOptions = [
        { label: 'Mobile', value: 'Mobile' },
        { label: 'Soft Phone', value: 'Soft Phone' },
        { label: 'WEBRTC', value: 'WEBRTC' },
    ];
    const loginStatusOptions = [
        { label: 'Active', value: '1' },
        { label: 'Inactive', value: '0' },
    ];

    

    // Fetch extensions for the dropdown
    useEffect(() => {
        getApiCall(API_AGENT_GROUP_EXTENSION)
            .then((data) => {
                const options = data.map((extension) => ({
                    label: extension.username,
                    value: extension.id,
                }));

                const updated = [{label: "Select Extension",
                    value: null}, ... options]
                setExtensionOptions(updated);
            })
            .catch((error) => {
                console.error('Error fetching extensions:', error);
                // setToastProps({ type: 'danger', message: 'Error fetching extensions.' });
          toast.error("Error fetching extensions.");
                setShowToast(true);
            });

        fetchAndSetFlashMessage(
        msg => msg.module_name === MODULE_ACL.AGENTS && msg.action === FLASH_MESSAGE_ACTION_OBJECT.ADD && msg.type === 'Note',
        setNotes
        );

        getApiCall(API_USER_COUNTRY_CODE_DIRECTIONS_ME, {})
            .then((data) => {
                const list = (Array.isArray(data) ? data : [])
                    .map((row) => row.directionMaster)
                    .filter(Boolean);
                setAvailableCcDirections(list);
            })
            .catch(() => setAvailableCcDirections([]));

        if (isEditMode && agentData?.id) {
            getApiCall(API_USER_COUNTRY_CODE_DIRECTIONS_BY_AGENT(agentData.id), {})
                .then((data) => {
                    const ids = (Array.isArray(data) ? data : [])
                        .map((row) => row.country_code_direction_id)
                        .filter(Boolean);
                    setSelectedCcDirections(ids);
                })
                .catch(() => {});
        }
    }, []);

    const validatePassword = (value) => {
  const rules = {
    length: value.length >= 8,
    upper: /[A-Z]/.test(value),
    lower: /[a-z]/.test(value),
    number: /[0-9]/.test(value),
    special: /[!@#$%^&*(),.?":{}|<>_\-\\[\]\/+=~`]/.test(value),
    space: !/\s/.test(value),
  };

  setPasswordRules(rules);

  if (value && !Object.values(rules).every(Boolean)) {
    setPasswordError("Password does not meet requirements");
  } else {
    setPasswordError("");
  }
};

    const handleSaveAgent = async () => {
        if (loading) return;
        if (emailError) {
            // setToastProps({ message: "Enter correct Email", type: "danger" });
          toast.error("Enter correct Email.");
            return;
        }
        if (!validateAgentName(agentName)) {
          toast.error(agentNameError || "Agent Name validation failed");
          return;
        }
        if (!validateUsername(username)) {
          toast.error(usernameError || "Username validation failed");
          return;
        }
        if (!type || type?.length < 1) {
          toast.error("Type required");
            return;
        }
        if (!type || type?.length < 1) {
          toast.error("Type required");
            return;
        }

        if (!isEditMode && !Object.values(passwordRules).every(Boolean)) {
            toast.error("Password must meet all requirements");
            return;
        }

     
        if(Array.isArray(type)&& !(type.includes('Soft Phone') ||type.includes('WEBRTC')) && selectedExtension){
          toast.error("Extension will be allocated only in case of Type Soft Phone or Type Webrtc.");
          return
        }
        if (type.includes("Mobile")) {
            if (!validateCountryCode(countryCode)) {
                toast.error(countryCodeError || "Invalid country code");
                return;
            }
        }

        if (type.includes("WEBRTC")) {
            if (!cliOption) {
                toast.error("Select incoming call display option");
                return;
            }
        }
        const payload = {
            agent_name: agentName,
            agent_number: Number(agentNumber),
            extension: selectedExtension ? [selectedExtension] : [],
            email_id: emailId,
            description,
            username,
            password,
            access,
            type,
            login_status: loginStatus,
            country_code: type.includes("Mobile") ? countryCode : null,
            cli_option: type.includes("WEBRTC") ? cliOption : null,
            is_outbound_enabled: !!isOutboundEnabled,
            country_code_directions: Array.isArray(selectedCcDirections)
                ? selectedCcDirections.map(Number)
                : [],
        };

        try {
            setLoading(true);
            if (isEditMode) {
                await postApiCall(`${API_AGENT_UPDATE}/${agentData.id}`, payload);
                // setToastProps({ type: 'success', message: 'Agent updated successfully.' });
          toast.success("Agent updated successfully");
                setShowToast(true);
                setTimeout(() => navigate('/agents'), 2000);
            } else {
                await postApiCall(AGENT_GROUP_CREATE, payload);
                // setToastProps({ type: 'success', message: 'Agent created successfully.' });
          toast.success("Agent created successfully");
                setShowToast(true);
                setTimeout(() => navigate('/agents'), 3000);
            }
        } catch (error) {
            const errorMessage =
                typeof error === "string"
                    ? error
                    : (error?.response?.data?.message || error?.message || String(error));
            const friendlyMessage = String(errorMessage).includes("Agent Number Already Exists")
                ? "Agent number must be unique. This number is already in use."
                : errorMessage;
            // setToastProps({ type: 'danger', message: errorMessage });
          toast.error(friendlyMessage);
            setShowToast(true);
        } finally {
            setLoading(false);
        }
    };

     const handleEmailChange = (e) => {
      const value = e.target.value;
      setEmailId(value);
      setEmailError(validateEmail(value));
    };

    const validateAgentName = (value) => {
      const trimmedValue = value.trim();
      if (!trimmedValue) {
        setAgentNameError("Agent Name is required");
        return false;
      }
      // Allow only letters, numbers, and underscores
      const nameRegex = /^[a-zA-Z0-9_]+$/;
      if (!nameRegex.test(trimmedValue)) {
        setAgentNameError("Agent Name can only contain letters, numbers, and underscores (_). No spaces or special characters allowed.");
        return false;
      }
      setAgentNameError("");
      return true;
    };

    const validateUsername = (value) => {
      const trimmedValue = value.trim();
      if (!trimmedValue) {
        setUsernameError("Username is required");
        return false;
      }
      // Allow only letters, numbers, and underscores
      const usernameRegex = /^[a-zA-Z0-9_]+$/;
      if (!usernameRegex.test(trimmedValue)) {
        setUsernameError("Username can only contain letters, numbers, and underscores (_). No spaces or special characters allowed.");
        return false;
      }
      setUsernameError("");
      return true;
    };

    const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    validatePassword(value);

    let errors = [];

    // Rule checks
    if (value.length < 8) {
        errors.push("At least 8 characters");
    }
    if (!/[A-Z]/.test(value)) {
        errors.push("At least 1 uppercase letter");
    }
    if (!/[a-z]/.test(value)) {
        errors.push("At least 1 lowercase letter");
    }
    if (!/[0-9]/.test(value)) {
        errors.push("At least 1 number");
    }
    if (!/[!@#$%^&*(),.?\":{}|<>]/.test(value)) {
        errors.push("At least 1 special character");
    }
    if (/\s/.test(value)) {
        errors.push("No spaces allowed");
    }

    if (value.length === 0) {
        setPasswordError("");
    } else if (errors.length > 0) {
        setPasswordError(errors);
    } else {
        setPasswordError("");
    }

    };

    const validateCountryCode = (value) => {
        if (!value) {
            setCountryCodeError("Country code is required");
            return false;
        }

        if (!/^\d{1,4}$/.test(value)) {
            setCountryCodeError("Only numbers allowed (1–4 digits)");
            return false;
        }

        setCountryCodeError("");
        return true;
    };

    return (
        <>
            <div style={{ marginTop: '20px' }}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-block justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">{isEditMode ? 'Edit Agent' : 'Create Agent'}</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <form>
                                    <Row className="mb-3">
                                         <div className="alert alert-warning d-flex align-items-center" role="alert">
                                                <i className="fa fa-info-circle me-2" style={{color: '#856404'}}></i>
                                                <div>
                                                    {/* Extension will be allocated only in case of Type Soft Phone or Type Webrtc. */}
                                                    <strong>Note: </strong>{notes.find(n => Number(n.priority) === 1)?.message ?? ""}
                                                </div>
                                            </div>
                                        <Col md="4">
                                            <label htmlFor="agentName" className="form-label">Agent Name <span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <input
                                                type="text"
                                                id="agentName"
                                                value={agentName}
                                                onChange={(e) => {
                                                  const value = e.target.value;
                                                  setAgentName(value);
                                                  validateAgentName(value);
                                                }}
                                                onBlur={(e) => validateAgentName(e.target.value)}
                                                className={`form-control ${agentNameError ? 'is-invalid' : ''}`}
                                                placeholder="Agent Name"
                                                required
                                                disabled={isEditMode}
                                            />
                                            {agentNameError && <div className="invalid-feedback">{agentNameError}</div>}
                                        </Col>
                                        <Col md="4">
                                            <label htmlFor="agentNumber" className="form-label">Agent Number <span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                maxLength={10}
                                                id="agentNumber"
                                                value={agentNumber}
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    if (/^\d{0,10}$/.test(val)) {
                                                        setAgentNumber(val);
                                                    }
                                                }}
                                                className="form-control"
                                                placeholder="Agent Number"
                                                required
                                            />
                                        </Col>
                                        <Col md="4">
                                            <label htmlFor="emailId" className="form-label">Email ID <span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <input
                                                type="email"
                                                id="emailId"
                                                value={emailId}
                                                onChange={handleEmailChange}
                                                className="form-control"
                                                placeholder="Email ID"
                                                required
                                            />
                                            {emailError && <span className="text-danger">{emailError}</span>}
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md="4">
                                            <label htmlFor="extensionDropdown" className="form-label">Extension</label>
                                            <Dropdown
                                                id="extensionDropdown"
                                                value={selectedExtension}
                                                style={{alignItems:"center"}}
                                                options={extensionOptions}
                                                onChange={(e) => setSelectedExtension(e.value)}
                                                placeholder="Select Extension"
                                                className="form-control"
                                            />
                                        </Col>
                                        <Col md="4">
                                            <label htmlFor="username" className="form-label">Username<span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <input
                                                type="text"
                                                id="username"
                                                autoComplete="off"
                                                value={username}
                                                readOnly
                                                onFocus={(e) => e.target.removeAttribute("readOnly")}
                                                onChange={(e) => {
                                                  const value = e.target.value;
                                                  setUsername(value);
                                                  validateUsername(value);
                                                }}
                                                onBlur={(e) => validateUsername(e.target.value)}
                                                className={`form-control ${usernameError ? 'is-invalid' : ''}`}
                                                placeholder="Username"
                                                required
                                            />
                                            {usernameError && <div className="invalid-feedback">{usernameError}</div>}
                                        </Col>
                                        <Col md="4">
                                            <label htmlFor="password" className="form-label">
                                            Password {!isEditMode && <span style={{ color: "red", margin: "0 4px" }}>*</span>}
                                            </label>

                                            <div style={{ position: "relative" }}>

                                            <input
                                            type={showPassword ? "text" : "password"}
                                            id="password"
                                            value={password}
                                            autoComplete="off"
                                            readOnly
                                            onFocus={(e) => e.target.removeAttribute("readOnly")}
                                            onChange={handlePasswordChange}
                                            className={`form-control ${passwordError ? "is-invalid" : ""}`}
                                            placeholder={
                                                isEditMode
                                                ? "Enter new password (leave blank to keep current)"
                                                : "Password"
                                            }
                                            required={!isEditMode}
                                            />

                                            <span
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                position: "absolute",
                                                right: "40px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                fontSize: "18px"
                                            }}
                                            >
                                            {showPassword ? <i class="fa-solid fa-eye-slash"></i> : <i class="fa-solid fa-eye"></i>}
                                            </span>

                                            </div>

                                            {Array.isArray(passwordError) && passwordError.length > 0 && (
                                            <div style={{ color: "#dc3545", fontSize: "13px", marginTop: "5px" }}>
                                                {passwordError.map((err, index) => (
                                                <div key={index}>• {err}</div>
                                                ))}
                                            </div>
                                            )}

                                        </Col>
                                    </Row>
                                    <Row className="mb-3" style={{marginTop:"-16px"}}>
                                        <Col md="4">
                                            <label htmlFor="accessDropdown" className="form-label">Access<span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <Dropdown
                                                id="accessDropdown"
                                                value={access}
                                                options={accessOptions}
                                                style={{height:"50%",alignItems:"center"}}
                                                onChange={(e) => setAccess(e.value)}
                                                placeholder="Select Access"
                                                className="form-control"
                                            />
                                        </Col>
                                        <Col md="5">
                                        <label htmlFor="typeDropdown" className="form-label">Type<span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                        <MultiSelect
                                            id="typeDropdown"
                                            value={type}
                                            options={
                                                selectedExtension === null
                                                ? [{ label: 'Mobile', value: 'Mobile' }]
                                                : typeOptions
                                            }
                                            onChange={(e) => setType(e.value)}
                                            placeholder="Select Type"
                                            className="form-control"
                                            display="chip" // optional: shows selected values as chips
                                            style={{ height: "50%", alignItems: "center"}}
                                            required
                                        />
                                        </Col>
                                        {/* <Col md="4">
                                            <label htmlFor="loginStatusDropdown" className="form-label">Login Status</label>
                                            <Dropdown
                                            style={{height:"50%",alignItems:"center"}}
                                                id="loginStatusDropdown"
                                                value={loginStatus}
                                                options={loginStatusOptions}
                                                onChange={(e) => setLoginStatus(e.value)}
                                                placeholder="Select Login Status"
                                                className="form-control"
                                            />
                                        </Col> */}
                                    </Row>
                                    {type.includes("Mobile") && (
                                        <Row className="mb-3" style={{ marginTop: "20px", marginBottom: "40px" }}>
                                            <Col md="4">
                                                <label className="form-label">
                                                    Country Code (Mobile) <span style={{ color: "red" }}>*</span>
                                                </label>

                                                <input
                                                    type="text"
                                                    inputMode="numeric"
                                                    maxLength={4}
                                                    value={countryCode}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        if (/^\d{0,4}$/.test(val)) {
                                                            setCountryCode(val);
                                                            validateCountryCode(val);
                                                        }
                                                    }}
                                                    className={`form-control ${countryCodeError ? "is-invalid" : ""}`}
                                                    placeholder="e.g. 91"
                                                />

                                                {countryCodeError && (
                                                    <div className="invalid-feedback">{countryCodeError}</div>
                                                )}
                                            </Col>
                                        </Row>
                                    )}
                                    {type.includes("WEBRTC") && (
                                        <Row style={{ marginTop: "20px", marginBottom: "40px" }}>
                                            <Col md="8">
                                                <label className="form-label">
                                                    Incoming Call Display (WEBRTC Only) <span style={{ color: "red" }}>*</span>
                                                </label>

                                                <div style={{ display: "flex", gap: "20px", marginTop: "8px" }}>
                                                    <div>
                                                        <input
                                                            type="radio"
                                                            id="actualNumber"
                                                            name="cliOption"
                                                            value="actual"
                                                            checked={cliOption === "actual"}
                                                            onChange={(e) => setCliOption(e.target.value)}
                                                        />
                                                        <label htmlFor="actualNumber" style={{ marginLeft: "6px" }}>
                                                            Show Actual Number
                                                        </label>
                                                    </div>

                                                    <div>
                                                        <input
                                                            type="radio"
                                                            id="virtualNumber"
                                                            name="cliOption"
                                                            value="virtual"
                                                            checked={cliOption === "virtual"}
                                                            onChange={(e) => setCliOption(e.target.value)}
                                                        />
                                                        <label htmlFor="virtualNumber" style={{ marginLeft: "6px" }}>
                                                            Show Virtual Number (Assigned CLI)
                                                        </label>
                                                    </div>

                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                    <Row className="mb-3">
                                        <Col md="6">
                                            <label className="form-label">Outbound Enabled</label>
                                            <div className="form-check form-switch" style={{ paddingTop: "6px" }}>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="isOutboundEnabled"
                                                    checked={!!isOutboundEnabled}
                                                    onChange={(e) => setIsOutboundEnabled(e.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor="isOutboundEnabled" style={{ marginLeft: "8px" }}>
                                                    {isOutboundEnabled ? "Enabled" : "Disabled"}
                                                </label>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <CountryCodeDirectionPicker
                                            items={availableCcDirections}
                                            selectedIds={selectedCcDirections}
                                            onChange={setSelectedCcDirections}
                                            label="Country Codes:"
                                            placeholder="Optional"
                                        />
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md="12">
                                            <label htmlFor="description" className="form-label">Description</label>
                                            <textarea
                                                id="description"
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                className="form-control"
                                                placeholder="Description"
                                                rows="3"
                                            ></textarea>
                                        </Col>
                                    </Row>
                                    <Button
                                        label={
                                            loading
                                                ? (isEditMode ? 'Updating...' : 'Creating...')
                                                : (isEditMode ? 'Update' : 'Create')
                                        }
                                        onClick={handleSaveAgent}
                                        className="p-button-primary mt-3"
                                        type="button"
                                        disabled={loading}
                                    />
                                </form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}
        </>
    );
}
